import { render, staticRenderFns } from "./NotificationsBtn.vue?vue&type=template&id=fcf84d98"
import script from "./NotificationsBtn.vue?vue&type=script&lang=ts"
export * from "./NotificationsBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports